import { useMemo } from 'react'
import { urlForImage } from 'lib/sanity.image'

import { PortableText } from '@portabletext/react'
import Image from 'next/image'

export const ContentBlock = ({ items }) => {
  const isOnly = useMemo(() => {
    return items.length === 1
  }, [items])

  return (
    <div className={`grid grid-cols-1 gap-20 px-20 py-10 md:grid-cols-2`}>
      {items.map((item) => {
        return (
          <div
            key={item._key}
            className={`flex flex-col rounded-10 bg-white p-20 shadow-md ${
              isOnly
                ? 'justify-between md:col-span-2 md:flex-row'
                : 'col-span-1'
            }`}
          >
            <div>
              {item.title ? (
                <h3 className="pb-24 text-16 font-medium leading-120 text-midGray">
                  {item.title}
                </h3>
              ) : null}
              <div className="max-w-[500px] text-12 leading-120 text-gray">
                <PortableText
                  value={item.text}
                  components={{
                    block: {
                      normal: ({ children }) => (
                        <p className="pb-10">{children}</p>
                      ),
                    },
                  }}
                />
              </div>
            </div>
            {item.image ? (
              <div
                className={`relative aspect-square w-full overflow-hidden rounded-6 ${
                  isOnly ? 'md:w-1/2' : 'mt-40'
                }`}
              >
                <Image
                  src={urlForImage(item.image).width(800).auto('format').url()}
                  alt={item.image.alt}
                  fill
                  style={{ objectFit: 'cover' }}
                  placeholder="blur"
                  blurDataURL={item.image.lqip}
                />
              </div>
            ) : null}
          </div>
        )
      })}
    </div>
  )
}
